import { 
    SET_FORM_PAX_DETAILS_VALID,
    SET_FORM_LEAD_PAX_DETAIS_VALID,
    SET_SIGNUP_PAX_FORM,
    SET_PAYMENT_FORM
 } from '../actions/types';
import update from 'immutability-helper';

const initialState = {
    paxDetailsValid:false,
    leadPaxDetailsValid:false
}

export function SetValidation(state = initialState, action){
    switch(action.type){
        case SET_FORM_PAX_DETAILS_VALID:
            return update(state, { paxDetailsValid:{$set:action.payload}});
        case SET_FORM_LEAD_PAX_DETAIS_VALID:
            return update(state, { leadPaxDetailsValid:{$set:action.payload}});     
        default:
            return state;
    }
}


const initialFormState = {
    signupForm:{},
    paymentForm:{}
}

export function SetForms(state = initialFormState, action){
    switch(action.type){
        case SET_SIGNUP_PAX_FORM:
            return update(state, { signupForm:{$set:action.payload}});
        case SET_PAYMENT_FORM:
            return update(state, { paymentForm:{$set:action.payload}});
        default:
            return state;
    }
}
